import { LocalLessonProviderData } from "@jelly/lesson";
import lesson01 from "./lesson-01/lesson";
import lessonLinks from "./lesson-01/lessonLinks";
import lesson02 from "./lesson-02/lesson";
import lesson03 from "./lesson-03/lesson";
import lesson04 from "./lesson-04/lesson";
import lesson05 from "./lesson-05/lesson";
import lesson06 from "./lesson-06/lesson";
import lesson07 from "./lesson-07/lesson";
import lesson08 from "./lesson-08/lesson";
import lesson09 from "./lesson-09/lesson";
import lesson10 from "./lesson-10/lesson";
import lesson11 from "./lesson-11/lesson";
import lesson12 from "./lesson-12/lesson";
import lesson13 from "./lesson-13/lesson";
import lesson14 from "./lesson-14/lesson";
import lesson15 from "./lesson-15/lesson";
import lesson16 from "./lesson-16/lesson";
import lesson17 from "./lesson-17/lesson";
import lesson18 from "./lesson-18/lesson";
import lesson19 from "./lesson-19/lesson";
import lesson20 from "./lesson-20/lesson";
import lesson21 from "./lesson-21/lesson";
import lesson22 from "./lesson-22/lesson";
import lesson23 from "./lesson-23/lesson";
import lesson24 from "./lesson-24/lesson";
import lesson25 from "./lesson-25/lesson";
import lesson26 from "./lesson-26/lesson";
import lesson27 from "./lesson-27/lesson";
import lesson28 from "./lesson-28/lesson";
import lesson29 from "./lesson-29/lesson";
import lesson30 from "./lesson-30/lesson";
import case01 from "./case-01/case";
import case02 from "./case-02/case";

const data: LocalLessonProviderData = {
  byId: {
    [lesson01.id]: lesson01,
    [lesson02.id]: lesson02,
    [lesson03.id]: lesson03,
    [lesson04.id]: lesson04,
    [lesson05.id]: lesson05,
    [lesson06.id]: lesson06,
    [lesson07.id]: lesson07,
    [lesson08.id]: lesson08,
    [lesson09.id]: lesson09,
    [lesson10.id]: lesson10,
    [lesson11.id]: lesson11,
    [lesson12.id]: lesson12,
    [lesson13.id]: lesson13,
    [lesson14.id]: lesson14,
    [lesson15.id]: lesson15,
    [lesson16.id]: lesson16,
    [lesson17.id]: lesson17,
    [lesson18.id]: lesson18,
    [lesson19.id]: lesson19,
    [lesson20.id]: lesson20,
    [lesson21.id]: lesson21,
    [lesson22.id]: lesson22,
    [lesson23.id]: lesson23,
    [lesson24.id]: lesson24,
    [lesson25.id]: lesson25,
    [lesson26.id]: lesson26,
    [lesson27.id]: lesson27,
    [lesson28.id]: lesson28,
    [lesson29.id]: lesson29,
    [lesson30.id]: lesson30,
    [case01.id]: case01,
    [case02.id]: case02,
  },
  linksById: {
    [lesson01.id]: lessonLinks,
    [lesson02.id]: [],
    [lesson03.id]: [],
    [lesson04.id]: [],
    [lesson05.id]: [],
    [lesson06.id]: [],
    [lesson07.id]: [],
    [lesson08.id]: [],
    [lesson09.id]: [],
    [lesson10.id]: [],
    [lesson11.id]: [],
    [lesson12.id]: [],
    [lesson13.id]: [],
    [lesson14.id]: [],
    [lesson15.id]: [],
    [lesson16.id]: [],
    [lesson17.id]: [],
    [lesson18.id]: [],
    [lesson19.id]: [],
    [lesson20.id]: [],
    [lesson21.id]: [],
    [lesson22.id]: [],
    [lesson23.id]: [],
    [lesson24.id]: [],
    [lesson25.id]: [],
    [lesson26.id]: [],
    [lesson27.id]: [],
    [lesson28.id]: [],
    [lesson29.id]: [],
    [lesson30.id]: [],
    [case01.id]: [],
    [case02.id]: [],
  },
};

export default data;
